const selectCommon = state => {
  return {
    ...state.common
  };
};

const selectAydinlatma = state => {
  return {
    ...state.common.aydinlatma
  };
};

export { selectCommon, selectAydinlatma };
